exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-filtering{position:static}.igx-filtering__toggle{z-index:10}.igx-filtering__toggle i{font-size:1em;line-height:1em;padding:.5em}.igx-filtering__toggle--active{background:#0375be!important;color:#fff}.igx-filtering__options{display:block;position:absolute;width:calc(100% - 32px);user-select:none;right:16px;left:16px;background:#fff;box-shadow:0 2px 4px -1px rgba(0,0,0,.26),0 4px 5px 0 rgba(0,0,0,.12),0 1px 10px 0 rgba(0,0,0,.08);border-radius:2px;padding:.5em;z-index:10;margin-top:8px}.igx-filtering__options>input{font-weight:400;font-size:medium}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/grid/column-filtering.component.scss
// module id = 38
// module chunks = 0 1